import * as types from './types';

export const fetch = () => ({
  type: types.FETCH
});
export const fetchSucceeded = (response) => ({
  type: types.FETCH_SUCCEEDED,
  payload: { response }
});
export const fetchFailed = () => ({
  type: types.FETCH_FAILED
});
